import { Stack } from '@mui/joy'
import { filters, ListTollRoads } from '~/features/TollRoad/ListTollRoads'
import { TollRoadsExport } from '~/entities/TollRoad'
import { usePermissions } from '~/entities/viewer'
import { formatDateTimeForApi } from '~/shared/lib/date'
import { pushFx } from '~/shared/lib/history'
import {
  getStringParams,
  useFiltersQueryParams,
} from '~/shared/ui/AsyncGrid/Filters'
import { Button } from '~/shared/ui/Buttons'
import { UploadIcon } from '~/shared/ui/Icons'
import { PageContainer, Container, PageTitle } from '~/shared/ui/Layout'

export function ListTollRoadsPage() {
  const { canExportTollRoadToBankClientExport } = usePermissions()

  const [filtersQueryParams] = useFiltersQueryParams(filters)
  const search = getStringParams(filtersQueryParams)

  const goToBankClient = () => {
    const frozenDateTime = formatDateTimeForApi(new Date())
    pushFx(`/toll-roads/unload/?frozenDateTime=${frozenDateTime}&${search}`)
  }

  return (
    <PageContainer title='Проезды ЦКАД и МСД'>
      <Container
        isHeader
        direction='row'
        justifyContent='space-between'
        alignItems='center'
      >
        <PageTitle>Проезды ЦКАД и МСД</PageTitle>

        <Stack spacing={2} direction='row'>
          <Button
            show={canExportTollRoadToBankClientExport}
            onClick={goToBankClient}
            startDecorator={<UploadIcon />}
          >
            Выгрузить в банк клиент
          </Button>
          <TollRoadsExport filters={filters} />
        </Stack>
      </Container>

      <Container>
        <ListTollRoads />
      </Container>
    </PageContainer>
  )
}
